import { awaitLandingAutosaveForWizardAdvance } from './auto-save';

export function ensureWizardLabelInvalidHelper() {
    if (typeof window.landingEmbedWizardSetLabelInvalid === 'function') {
        return;
    }

    const getLabelForEl = (el) => {
        if (!el) {
            return $();
        }
        const $el = $(el);
        const id = $el.attr('id');
        const $field = $el.closest('.field, .phone-wrapper, .field-body');
        let $label = $();

        if (id) {
            $label = $field.find(`label.label[for="${id}"]`).first();
        }
        if (!$label.length) {
            $label = $field.closest('.field').find('.field-label label.label').first();
        }
        if (!$label.length) {
            $label = $field.find('label.label').first();
        }
        if (!$label.length) {
            $label = $el.closest('.phone-wrapper').find('label.label').first();
        }
        return $label.length ? $label : $();
    };

    window.landingEmbedWizardSetLabelInvalid = (el, isInvalid) => {
        const $label = getLabelForEl(el);
        if (!$label.length) {
            return;
        }
        $label.toggleClass('is-danger', !!isInvalid);
        $label.toggleClass('is-invalid', !!isInvalid);
        if (isInvalid) {
            $label.removeClass('is-checking');
        }
    };

    window.landingEmbedWizardSetLabelChecking = (el, isChecking) => {
        const $label = getLabelForEl(el);
        if (!$label.length) {
            return;
        }
        $label.toggleClass('is-checking', !!isChecking);
        if (isChecking) {
            $label.removeClass('is-danger is-invalid');
        }
    };

    window.landingEmbedWizardSetLabelColor = (el, color) => {
        const $label = getLabelForEl(el);
        if (!$label.length) {
            return;
        }
        $label[0].style.color = color || '';
    };
}

export function getWizardStepFieldElements($step) {
    const $stepEl = $($step);
    if ($stepEl.hasClass('extra-question')) {
        return $stepEl.find('.field .control').find('input, select, textarea');
    }
    const $controls = $stepEl.find('.control');
    if ($controls.length) {
        return $controls.find('input, select, textarea');
    }
    return $stepEl.find('input, select, textarea');
}

export function wizardFieldHasValue(val) {
    return val !== undefined && val !== null && String(val).trim() !== '';
}

export function getWizardFieldValue($el) {
    const $field = $($el);
    if ($field.is('select') && $field.hasClass('select2-hidden-accessible')) {
        const val = $field.val();
        if (wizardFieldHasValue(val)) {
            return val;
        }
    }
    return $field.val();
}

export function wizardClearFieldErrors($form, element) {
    const $el = $(element);
    const fieldId = $el.attr('id');
    const name = ($el.attr('name') || '').replace(/[\[\]]/g, '');
    $el.removeClass('is-danger error');
    if ($el.hasClass('select2-hidden-accessible')) {
        $el.next('.select2-container').removeClass('is-danger');
    }
    if (fieldId) {
        $(`#error_${fieldId}`).removeClass('show').empty();
    }
    if (name) {
        $(`#error_${name}`).removeClass('show').empty();
        if (fieldId && name !== fieldId) {
            $(`#error_questions${fieldId.replace(/^select_|^number_|^text_/, '')}`).removeClass('show').empty();
        }
    }
    if (typeof window.landingEmbedWizardSetLabelInvalid === 'function') {
        window.landingEmbedWizardSetLabelInvalid(element, false);
    }
}

export function wizardFieldIsEmpty(element) {
    const $el = $(element);
    if ($el.is('select')) {
        return !wizardFieldHasValue(getWizardFieldValue($el));
    }
    const val = $el.val();
    return val === undefined || val === null || String(val).trim() === '';
}

export function wizardResetJqueryValidateDeferredElement(validator, element) {
    if (!validator || !element || !element.name) {
        return;
    }
    if (validator.invalid && Object.prototype.hasOwnProperty.call(validator.invalid, element.name)) {
        delete validator.invalid[element.name];
    }
    if (validator.submitted && Object.prototype.hasOwnProperty.call(validator.submitted, element.name)) {
        delete validator.submitted[element.name];
    }
}

export function wizardShouldDeferJqueryValidateForElement($form, element, wizardNextAttemptedByStep, stepIndex, $currentStep) {
    if (!element || !$form.closest('.form-wrapper').hasClass('landing-wizard-active')) {
        return false;
    }
    if (!$currentStep || !$currentStep.length || !$currentStep[0].contains(element)) {
        return false;
    }
    if (wizardNextAttemptedByStep && wizardNextAttemptedByStep[stepIndex]) {
        return false;
    }
    return wizardFieldIsEmpty(element);
}

export function patchWizardValidatorDelegates($form, wizardNextAttemptedByStep, getStepIndex, getCurrentStep) {
    const validator = $form.data('validator');
    if (!validator || validator.__landingWizardValidateHooked) {
        return;
    }
    validator.__landingWizardValidateHooked = true;
    const origOnfocusout = validator.settings.onfocusout;
    const origOnkeyup = validator.settings.onkeyup;

    validator.settings.onfocusout = function (element, event) {
        const idx = getStepIndex();
        const $current = getCurrentStep();
        if (wizardShouldDeferJqueryValidateForElement($form, element, wizardNextAttemptedByStep, idx, $current)) {
            wizardClearFieldErrors($form, element);
            wizardResetJqueryValidateDeferredElement(this, element);
            return;
        }
        if (typeof origOnfocusout === 'function') {
            return origOnfocusout.call(this, element, event);
        }
    };

    validator.settings.onkeyup = function (element, event) {
        const idx = getStepIndex();
        const $current = getCurrentStep();
        if (wizardShouldDeferJqueryValidateForElement($form, element, wizardNextAttemptedByStep, idx, $current)) {
            wizardClearFieldErrors($form, element);
            wizardResetJqueryValidateDeferredElement(this, element);
            return;
        }
        if (typeof origOnkeyup === 'function') {
            return origOnkeyup.call(this, element, event);
        }
    };
}

export function patchEmbedFormWizardValidatorSettings($form) {
    const validator = $form.data('validator');
    if (!validator) {
        return;
    }

    ensureWizardLabelInvalidHelper();
    validator.settings.__landingWizardSuppressErrors = true;
    validator.settings.errorElement = 'span';
    validator.settings.errorClass = 'is-danger';
    validator.settings.validClass = '';

    const origErrorPlacement = validator.settings.errorPlacement;
    const origSuccess = validator.settings.success;

    validator.settings.errorPlacement = function (error, element) {
        if (this && this.settings && this.settings.__landingWizardSuppressErrors === true) {
            if (typeof this.errorsFor === 'function') {
                this.errorsFor(element).remove();
            }
            if (error && typeof error.remove === 'function') {
                error.remove();
            }
            const name = (element.attr('name') || '').replace(/[\[\]]/g, '');
            const id = element.attr('id');
            if (name) {
                $(`#${name}-error`).remove();
            }
            if (id) {
                $(`#${id}-error`).remove();
            }
            if (name) {
                $(`#error_${name}`).removeClass('show').empty();
            }
            if (id) {
                $(`#error_${id}`).removeClass('show').empty();
            }
            if (element.hasClass('select2-hidden-accessible')) {
                element.next('.select2-container').toggleClass('is-danger', true);
            }
            if (typeof window.landingEmbedWizardSetLabelInvalid === 'function') {
                window.landingEmbedWizardSetLabelInvalid(element[0], true);
            }
            return;
        }
        if (typeof origErrorPlacement === 'function') {
            return origErrorPlacement.call(this, error, element);
        }
    };

    validator.settings.success = function (label, element) {
        if (typeof origSuccess === 'function') {
            origSuccess.call(this, label, element);
        }
        wizardClearFieldErrors($form, element);
    };
}

export function isWizardStepFilled($form, $step) {
    const $stepEl = $($step);
    const phoneEl = $stepEl.find('input[name="phone"]').first()[0];
    if (phoneEl && phoneEl.whatsappValidated === true) {
        return true;
    }
    let ok = true;
    getWizardStepFieldElements($stepEl).each((_, el) => {
        const $el = $(el);
        const type = $el.attr('type');
        if (type === 'hidden' && !$el.hasClass('landing-embed-option-value')) {
            return;
        }
        const name = $el.attr('name');
        if (name === '_token' || name === 'language') {
            return;
        }
        if ($el.is(':checkbox') || $el.is(':radio')) {
            return;
        }
        if ($el.hasClass('landing-embed-option-value') || $el.hasClass('landing-embed-number-wheel-input')) {
            if (!wizardFieldHasValue(getWizardFieldValue($el))) {
                ok = false;
            }
            return;
        }
        if ($el.is('select')) {
            if (!wizardFieldHasValue(getWizardFieldValue($el))) {
                ok = false;
            }
            return;
        }
        let val = getWizardFieldValue($el);
        if (!wizardFieldHasValue(val) && $el.attr('name') === 'phone') {
            const id = $el.attr('id');
            const inter = id ? $stepEl.find(`#inter-${id}`).val() : null;
            val = inter;
        }
        if (!wizardFieldHasValue(val)) {
            ok = false;
        }
    });
    return ok;
}

function wizardFieldPassesRuleValidation($el, el, validator, rules, name, id, stepHidden) {
    const isPhoneWhatsappOk = (name === 'phone' || id === 'phone') && el && el.whatsappValidated === true;
    if (isPhoneWhatsappOk) {
        return true;
    }

    const useValueCheck =
        stepHidden
        || $el.hasClass('select2-hidden-accessible')
        || $el.hasClass('landing-embed-option-value')
        || $el.hasClass('landing-embed-number-wheel-input');

    if (!useValueCheck) {
        return validator.element(el) !== false;
    }

    if (!wizardFieldHasValue(getWizardFieldValue($el))) {
        return false;
    }

    if ((name === 'email' || id === 'email') && rules.email && typeof $.validator !== 'undefined' && $.validator.methods) {
        const value = String($el.val() || '').trim();
        if ($.validator.methods.email && $.validator.methods.email.call(validator, value, el) === false) {
            return false;
        }
        const pattern = rules.email.pattern;
        if (pattern) {
            const re = pattern instanceof RegExp ? pattern : new RegExp(pattern);
            if (!re.test(value)) {
                return false;
            }
        }
    }

    return true;
}

export function isWizardStepValid($form, $step, applyUi = true) {
    const validator = $form.data('validator');
    const rules = validator && validator.settings ? validator.settings.rules : null;
    const $stepEl = $($step);
    const stepHidden = $stepEl.hasClass('hidden');
    let ok = true;

    getWizardStepFieldElements($stepEl).each((_, el) => {
        const $el = $(el);
        const type = $el.attr('type');
        if (type === 'hidden' && !$el.hasClass('landing-embed-option-value')) {
            return;
        }
        const name = $el.attr('name');
        if (name === '_token' || name === 'language') {
            return;
        }
        const id = $el.attr('id');

        const setInvalidUi = () => {
            if (!applyUi) {
                return;
            }
            $el.addClass('is-danger');
            if ($el.hasClass('select2-hidden-accessible')) {
                $el.next('.select2-container').addClass('is-danger');
            }
            if (typeof window.landingEmbedWizardSetLabelInvalid === 'function') {
                window.landingEmbedWizardSetLabelInvalid(el, true);
            }
        };

        const clearUi = () => {
            if (!applyUi) {
                return;
            }
            wizardClearFieldErrors($form, el);
        };

        if ($el.hasClass('landing-embed-option-value') || $el.hasClass('landing-embed-number-wheel-input')) {
            const hasVal = wizardFieldHasValue(getWizardFieldValue($el));
            if (!hasVal) {
                ok = false;
                if (applyUi) {
                    setInvalidUi();
                }
            } else if (applyUi) {
                clearUi();
            }
            return;
        }

        if (validator && rules && (rules[name] || rules[id])) {
            const isOk = wizardFieldPassesRuleValidation($el, el, validator, rules, name, id, stepHidden);
            if (!isOk) {
                ok = false;
            }
            if (applyUi && typeof window.landingEmbedWizardSetLabelInvalid === 'function') {
                window.landingEmbedWizardSetLabelInvalid(el, !isOk);
            }
            if (applyUi && $el.hasClass('select2-hidden-accessible')) {
                $el.next('.select2-container').toggleClass('is-danger', !isOk);
            }
            if (applyUi) {
                $el.toggleClass('is-danger', !isOk);
            }
            return;
        }

        if ($el.is('select')) {
            const isOk = wizardFieldHasValue(getWizardFieldValue($el));
            if (!isOk) {
                ok = false;
            }
            if (applyUi) {
                $el.toggleClass('is-danger', !isOk);
                $el.next('.select2-container').toggleClass('is-danger', !isOk);
                if (typeof window.landingEmbedWizardSetLabelInvalid === 'function') {
                    window.landingEmbedWizardSetLabelInvalid(el, !isOk);
                }
            }
            return;
        }

        if ($el.is(':checkbox') || $el.is(':radio')) {
            return;
        }

        const val = $el.val();
        const hasVal = !!(val && String(val).trim());
        const formatOk = typeof el.checkValidity === 'function' ? el.checkValidity() : true;
        const isOk = hasVal && formatOk;
        if (!isOk) {
            ok = false;
        }
        if (applyUi) {
            $el.toggleClass('is-danger', !isOk);
            if (typeof window.landingEmbedWizardSetLabelInvalid === 'function') {
                window.landingEmbedWizardSetLabelInvalid(el, !isOk);
            }
        }
    });

    return ok;
}

export function wizardNormalizeCurrentStepVisualState($step) {
    getWizardStepFieldElements($($step)).each((_, el) => {
        const $el = $(el);
        const type = $el.attr('type');
        if (type === 'hidden' && !$el.hasClass('landing-embed-option-value')) {
            return;
        }
        if ($el.attr('name') === '_token') {
            return;
        }
        $el.removeClass('is-danger error');
        if ($el.hasClass('select2-hidden-accessible')) {
            $el.next('.select2-container').removeClass('is-danger');
        }
        if (typeof window.landingEmbedWizardSetLabelInvalid === 'function') {
            window.landingEmbedWizardSetLabelInvalid(el, false);
        }
    });
}

export function wizardSyncPhoneValidationState(el, wizardNextAttemptedByStep, stepIndex, hooks = {}) {
    if (!el) {
        return;
    }
    const $el = $(el);
    const val = $el.val();
    const hasVal = !!(val && String(val).trim());
    const nextAttempted = !!(wizardNextAttemptedByStep && wizardNextAttemptedByStep[stepIndex]);
    const statusEl = el.validationWrapper ? el.validationWrapper.whatsappStatus : null;

    const clearUi = () => {
        $el.removeClass('is-danger error');
        if (typeof window.landingEmbedWizardSetLabelInvalid === 'function') {
            window.landingEmbedWizardSetLabelInvalid(el, false);
        }
        if (typeof window.landingEmbedWizardSetLabelChecking === 'function') {
            window.landingEmbedWizardSetLabelChecking(el, false);
        }
        if (typeof window.landingEmbedWizardSetLabelColor === 'function') {
            window.landingEmbedWizardSetLabelColor(el, '');
        }
    };

    const setInvalidUi = () => {
        $el.addClass('is-danger');
        if (typeof window.landingEmbedWizardSetLabelInvalid === 'function') {
            window.landingEmbedWizardSetLabelInvalid(el, true);
        }
        if (typeof window.landingEmbedWizardSetLabelChecking === 'function') {
            window.landingEmbedWizardSetLabelChecking(el, false);
        }
        if (typeof window.landingEmbedWizardSetLabelColor === 'function') {
            window.landingEmbedWizardSetLabelColor(el, '');
        }
    };

    if (typeof hooks.onAfterSync === 'function') {
        hooks.onAfterSync();
    }

    const errorMsgEl = el.validationWrapper ? el.validationWrapper.errorMsg : null;
    const errorMsgVisible = !!(errorMsgEl && !errorMsgEl.classList.contains('hide'));
    if (errorMsgVisible) {
        el.whatsappValidated = false;
        setInvalidUi();
        if (typeof window.landingEmbedWizardSetLabelColor === 'function') {
            window.landingEmbedWizardSetLabelColor(el, '#F43F5E');
        }
        return;
    }

    const statusVisible = !!(statusEl && !statusEl.classList.contains('hide'));
    if (statusVisible) {
        const wrapper = el.validationWrapper || null;
        const loaderEl = wrapper ? wrapper.loader : null;
        const validatedEl = wrapper ? wrapper.validated : null;
        const loaderVisible = !!(loaderEl && !loaderEl.classList.contains('hide'));
        const validatedVisible = !!(validatedEl && !validatedEl.classList.contains('hide'));
        const isInvalidStatus = statusEl.classList.contains('is-invalid');

        if (isInvalidStatus) {
            el.whatsappValidated = false;
            el.lastValue = $el.val();
            el.pendingRequest = null;
            setInvalidUi();
            return;
        }

        if (loaderVisible && !validatedVisible && el.whatsappValidated !== true) {
            if (typeof window.landingEmbedWizardSetLabelInvalid === 'function') {
                window.landingEmbedWizardSetLabelInvalid(el, false);
            }
            if (typeof window.landingEmbedWizardSetLabelChecking === 'function') {
                window.landingEmbedWizardSetLabelChecking(el, hasVal);
            }
            if (typeof window.landingEmbedWizardSetLabelColor === 'function') {
                window.landingEmbedWizardSetLabelColor(
                    el,
                    statusEl.style && statusEl.style.color ? statusEl.style.color : 'orange'
                );
            }
            return;
        }

        el.whatsappValidated = true;
        el.lastValue = $el.val();
        el.pendingRequest = null;
        clearUi();
        return;
    }

    if (el.whatsappValidated === true) {
        el.pendingRequest = null;
        clearUi();
        return;
    }

    const checking =
        !!el.pendingRequest ||
        !!(el.validationWrapper && el.validationWrapper.loader && !el.validationWrapper.loader.classList.contains('hide'));
    if (checking && typeof window.landingEmbedWizardSetLabelChecking === 'function') {
        window.landingEmbedWizardSetLabelChecking(el, hasVal);
        if (typeof window.landingEmbedWizardSetLabelColor === 'function') {
            const checkingColor =
                statusEl && statusEl.style && statusEl.style.color ? statusEl.style.color : 'orange';
            window.landingEmbedWizardSetLabelColor(el, checkingColor);
        }
        return;
    }

    if (!hasVal) {
        if (!nextAttempted) {
            clearUi();
        }
        return;
    }

    const isInvalid = el.classList && (el.classList.contains('error') || el.classList.contains('is-danger'));
    if (isInvalid) {
        setInvalidUi();
    } else {
        clearUi();
    }
}

export function wizardLiveSyncFieldFromEvent(ctx, e) {
    let el = e.target;
    if (el && el.closest && el.closest('.iti')) {
        const tel = el.closest('.iti').querySelector('input[name]:not([type="hidden"])');
        if (tel) {
            el = tel;
        }
    }
    const $current = ctx.getCurrentStep();
    if (!$current.length || !el || !$current[0].contains(el)) {
        return;
    }

    ctx.updateWizardNextState();

    if (el.getAttribute && el.getAttribute('name') === 'phone') {
        setTimeout(() => wizardSyncPhoneValidationState(el, ctx.wizardNextAttemptedByStep, ctx.getStepIndex()), 0);
    }

    const validator = ctx.$form.data('validator');
    const rules = validator && validator.settings ? validator.settings.rules : null;
    const $el = $(el);
    const type = $el.attr('type');
    const name = $el.attr('name');
    const id = $el.attr('id');
    const nextAttempted = !!(ctx.wizardNextAttemptedByStep && ctx.wizardNextAttemptedByStep[ctx.getStepIndex()]);

    if (name === '_token' || name === 'language') {
        return;
    }
    if (type === 'hidden' && !$el.hasClass('landing-embed-option-value')) {
        return;
    }

    const clearUi = () => wizardClearFieldErrors(ctx.$form, el);
    const setInvalidUi = () => {
        $el.addClass('is-danger');
        if ($el.hasClass('select2-hidden-accessible')) {
            $el.next('.select2-container').addClass('is-danger');
        }
        if (typeof window.landingEmbedWizardSetLabelInvalid === 'function') {
            window.landingEmbedWizardSetLabelInvalid(el, true);
        }
    };

    if ($el.hasClass('landing-embed-option-value')) {
        const hasVal = wizardFieldHasValue(getWizardFieldValue($el));
        if (!hasVal && !nextAttempted) {
            clearUi();
            return;
        }
        if (hasVal) {
            clearUi();
        }
        return;
    }

    if (validator && rules && (rules[name] || rules[id])) {
        const raw = $el.val();
        const hasVal = raw !== undefined && raw !== null && String(raw).trim() !== '';
        if (!hasVal) {
            if (!nextAttempted) {
                clearUi();
            }
            return;
        }
        const isOk = validator.element(el) !== false;
        if (isOk) {
            clearUi();
        } else {
            setInvalidUi();
        }
        return;
    }

    if ($el.is('select')) {
        const hasVal = wizardFieldHasValue(getWizardFieldValue($el));
        if (hasVal) {
            clearUi();
        } else if (!nextAttempted) {
            clearUi();
        }
        return;
    }

    if ($el.is(':checkbox') || $el.is(':radio')) {
        return;
    }

    const val = $el.val();
    const hasVal = !!(val && String(val).trim());
    const formatOk = typeof el.checkValidity === 'function' ? el.checkValidity() : true;
    if (!hasVal) {
        if (!nextAttempted) {
            clearUi();
        }
        return;
    }
    if (hasVal && formatOk) {
        clearUi();
        return;
    }
    setInvalidUi();
}

export function focusFirstFieldInWizardStep($step) {
    if (!$step || !$step.length) {
        return;
    }
    setTimeout(() => {
        const $phone = $step.find('.iti input[type="tel"]').first();
        if ($phone.length && $phone.is(':visible')) {
            $phone.trigger('focus');
            return;
        }
        const $wheel = $step.find('.landing-embed-number-wheel-viewport').first();
        if ($wheel.length && $wheel.is(':visible')) {
            $wheel.trigger('focus');
            return;
        }
        const $field = $step
            .find(
                'input:not([type="hidden"]):not([disabled]):not(.landing-embed-number-wheel-input), textarea:not([disabled]), select:not([disabled]):not(.select2-hidden-accessible)'
            )
            .filter(':visible')
            .first();
        if ($field.length) {
            $field.trigger('focus');
            return;
        }
        const $optionBtn = $step.find('.landing-embed-option-btn').filter(':visible').first();
        if ($optionBtn.length) {
            $optionBtn.trigger('focus');
        }
    }, 0);
}

export function updateWizardNextState(ctx) {
    if (!ctx.$wizardNext) {
        return;
    }
    const $current = ctx.getCurrentStep();
    const isFilled = isWizardStepFilled(ctx.$form, $current);
    let shouldBlockClick = false;

    const phoneEl = $current.find('input[name="phone"]').first()[0];
    if (isFilled && phoneEl && phoneEl.whatsappValidated !== true) {
        const wrapper = phoneEl.validationWrapper;
        const statusEl = wrapper ? wrapper.whatsappStatus : null;
        const loaderEl = wrapper ? wrapper.loader : null;
        const isChecking = !!phoneEl.pendingRequest || !!(loaderEl && !loaderEl.classList.contains('hide'));
        if (isChecking) {
            shouldBlockClick = true;
        }
    }

    ctx.$wizardNext.prop('disabled', shouldBlockClick);
    ctx.$wizardNext.toggleClass('is-disabled', shouldBlockClick);
    ctx.$wizardNext.attr('aria-disabled', shouldBlockClick ? 'true' : 'false');
}

const EMBED_FORM_OPTIONAL_RULE_NAMES = ['destination', 'city_id', 'visa_type', 'visa_month', 'visa_year'];

export function pruneEmbedFormValidatorRulesForMissingFields($form, validator) {
    if (!validator || !validator.settings || !validator.settings.rules) {
        return;
    }
    EMBED_FORM_OPTIONAL_RULE_NAMES.forEach((name) => {
        if (!$form.find(`[name="${name}"]`).length) {
            delete validator.settings.rules[name];
        }
    });
}

export function ensureEmbedFormQuestionValidatorRules($form, validator) {
    if (!validator || !validator.settings) {
        return;
    }
    if (!validator.settings.rules) {
        validator.settings.rules = {};
    }
    $form.find('[name^="questions["]').each(function () {
        const name = this.name;
        if (!name) {
            return;
        }
        validator.settings.rules[name] = { required: true };
    });
}

function wizardStepIndexForElement(steps, element) {
    if (!element || !steps || !steps.length) {
        return -1;
    }
    let found = -1;
    steps.each((i, stepEl) => {
        if (found >= 0) {
            return;
        }
        if (stepEl.contains(element)) {
            found = i;
        }
    });
    return found;
}

async function awaitEmbedFormPendingValidation($form) {
    const $phone = $form.find('input[name="phone"]').first();
    if ($phone.length && $phone[0] && $phone[0].validationTimer && !$phone[0].pendingRequest) {
        await new Promise((resolve) => setTimeout(resolve, 650));
    }
    const pending = [];
    $form.find('input, select, textarea').each((_, el) => {
        const p = el && el.pendingRequest;
        if (p && typeof p.then === 'function') {
            pending.push(p);
        }
    });
    if (pending.length) {
        await Promise.allSettled(pending);
    }
}

export async function submitEmbedLandingWizardForm(ctx) {
    const { $form, wizardNextAttemptedByStep, getStepIndex, setStepIndex, getSteps, updateWizardVisibility, $wizardNext, syncNumberWheels } = ctx;
    const steps = getSteps();
    const max = steps.length - 1;
    const idx = getStepIndex();
    if (idx < max) {
        return false;
    }

    if (typeof syncNumberWheels === 'function') {
        syncNumberWheels();
    }

    if (wizardNextAttemptedByStep) {
        wizardNextAttemptedByStep[idx] = true;
    }

    const $current = $(steps.get(idx));
    if (!isWizardStepFilled($form, $current) || !isWizardStepValid($form, $current, true)) {
        return false;
    }

    if ($wizardNext) {
        $wizardNext.addClass('is-loading');
    }

    try {
        await awaitEmbedFormPendingValidation($form);

        const phoneEl = $form.find('input[name="phone"]').first()[0];
        if (phoneEl && phoneEl.whatsappValidated !== true) {
            const phoneIdx = wizardStepIndexForElement(steps, phoneEl);
            if (phoneIdx >= 0 && phoneIdx !== idx) {
                if (wizardNextAttemptedByStep) {
                    wizardNextAttemptedByStep[phoneIdx] = true;
                }
                setStepIndex(phoneIdx);
                updateWizardVisibility();
                isWizardStepValid($form, $(steps.get(phoneIdx)), true);
            } else {
                isWizardStepValid($form, $current, true);
            }
            return false;
        }

        const validator = $form.data('validator');
        if (!validator) {
            if (typeof window.submitLandingEmbedWizardPost === 'function') {
                await window.submitLandingEmbedWizardPost($form);
                return true;
            }
            $form[0].submit();
            return true;
        }

        pruneEmbedFormValidatorRulesForMissingFields($form, validator);

        if (typeof window.submitLandingEmbedWizardPost === 'function') {
            await window.submitLandingEmbedWizardPost($form);
            return true;
        }

        const submitHandler = validator.settings.submitHandler;
        if (typeof submitHandler === 'function') {
            submitHandler.call(validator, $form[0]);
            return true;
        }
        $form[0].submit();
        return true;
    } finally {
        if ($wizardNext) {
            $wizardNext.removeClass('is-loading');
        }
    }
}

export async function advanceWizardStepWithValidation(ctx) {
    if (ctx.wizardNextBusy) {
        return false;
    }
    ctx.wizardNextBusy = true;
    let advanced = false;
    try {
        const idx = ctx.getStepIndex();
        const $current = ctx.getCurrentStep();
        if (ctx.wizardNextAttemptedByStep) {
            ctx.wizardNextAttemptedByStep[idx] = true;
        }

        if (!isWizardStepFilled(ctx.$form, $current)) {
            isWizardStepValid(ctx.$form, $current, true);
            return false;
        }

        const $phone = $current.find('input[name="phone"]').first();
        if ($phone.length && $phone[0] && $phone[0].validationTimer && !$phone[0].pendingRequest) {
            await new Promise((r) => setTimeout(r, 650));
        }

        const pending = [];
        $current.find('input, select, textarea').each((_, el) => {
            const p = el && el.pendingRequest;
            if (p && typeof p.then === 'function') {
                pending.push(p);
            }
        });
        const showAdvanceLoader = !!(ctx.$wizardNext && (pending.length || window.__landingAutosave));
        if (showAdvanceLoader) {
            ctx.$wizardNext.addClass('is-loading');
        }
        if (pending.length) {
            await Promise.allSettled(pending);
        }

        let stepValid = isWizardStepValid(ctx.$form, $current, true);
        if (!stepValid && $phone.length && $phone[0] && $phone[0].whatsappValidated === true) {
            stepValid = true;
        }
        if (!stepValid) {
            if (showAdvanceLoader) {
                ctx.$wizardNext.removeClass('is-loading');
            }
            return false;
        }

        const autosaveOk = await awaitLandingAutosaveForWizardAdvance();
        if (!autosaveOk) {
            if (showAdvanceLoader) {
                ctx.$wizardNext.removeClass('is-loading');
            }
            return false;
        }

        const max = ctx.getSteps().length - 1;
        if (idx < max) {
            ctx.setStepIndex(idx + 1);
            if (ctx.wizardNextAttemptedByStep) {
                ctx.wizardNextAttemptedByStep[ctx.getStepIndex()] = false;
            }
            ctx.updateWizardVisibility();
            wizardNormalizeCurrentStepVisualState(ctx.getCurrentStep());
            advanced = true;
        }
        return advanced;
    } finally {
        ctx.wizardNextBusy = false;
        if (ctx.$wizardNext) {
            ctx.$wizardNext.removeClass('is-loading');
        }
    }
}
